import type { Service } from '../../types/api';
import type { HeroSlide } from '../ui';
import { summary } from '../../utils/text';

/** Un service devient une slide: secteur en eyebrow, nom en titre, première phrase de sa description. */
export const serviceToSlide = (s: Service): HeroSlide => ({
  id: s.id,
  image: s.cover_image?.url ?? '',
  eyebrow: s.sector?.name ?? 'Services',
  title: s.name,
  text: summary(s.description, 120),
  label: s.name,
  to: `/services/${s.id}`,
  cta: 'Découvrir le service',
});

export const heroSlides = (services: Service[], max = 3): HeroSlide[] =>
  services.filter((s) => s.cover_image?.url).slice(0, max).map(serviceToSlide);
